import { getToken, onMessage } from "firebase/messaging";
import { BasicFetch } from './utils/BasicFetch.ts';
import { toast } from 'react-toastify';
import { ReptoolToast } from './components/utilities/Toast.tsx';

const firebaseGetToken = () => {
  (window as any).FirebasePlugin.getToken((currentToken: string) => {
    if (currentToken) {
      const data = {
        deviceId: currentToken,
      };

      BasicFetch({
        url: `${(window as any).serverLocation}user/register_device`,
        method: 'POST',
        extra: data,
        onSuccess: (response: any) => {
            
        },
        onFail: (error: any) => {
            
        }
      });
    }
  }, (error: any) => {
      
  });
}


export const initAppNotifications = () => {
    console.log('Initializing app notifications');

    (window as any).FirebasePlugin.hasPermission((permissionGranted: boolean) => {
        console.log('Permission granted:', permissionGranted);
        if (permissionGranted) {
            firebaseGetToken();
        } else {
          (window as any).FirebasePlugin.grantPermission((permission: any) => {
            console.log('Permission granted:', permission);
            if (permission) {
                firebaseGetToken();
            } else {

            }
          }, (error: any) => {
          });
        }
      }, (error: any) => {

      });
    if ((window as any).FirebasePlugin && typeof (window as any).FirebasePlugin.onMessageReceived === 'function') {
        (window as any).FirebasePlugin.onMessageReceived((payload: any) => {
        if (payload?.notification) {
            toast(ReptoolToast, { data: payload.notification });
        }
    }, (error: any) => {
    });
    }
}

export const initWebNotifications = async (messaging) => {
    const vapidKey = "BMwxhXZDUul8AN2C2VXGWntMG1XVYUn_qM-_Dv9-afYmrwACBz3xlm113WN4dNz50bnx3a-XS12IJVqmhJE7tVg";
    if (!navigator.serviceWorker) {
        console.log('Service worker not supported');
        return;
    }
    navigator.serviceWorker.register('/firebase-messaging-sw.js')
  .then((registration) => {
    // Use this service worker to get the token
    getToken(messaging, { vapidKey, serviceWorkerRegistration: registration })
      .then((currentToken) => {
        if (currentToken) {
          // Send the token to your server and update the UI if necessary
          const data = {
            deviceId: currentToken,
          }
          BasicFetch({
            url: `${(window as any).serverLocation}user/register_device`,
            method: 'POST',
            extra: data,
            onSuccess: (response) => {
            },
            onFail: (error) => {
            }
          })
        }
      })
      .catch((err) => {
      });
    onMessage(messaging, (payload) => {
        toast(ReptoolToast, {data: payload.notification});
    });
  })    
}